import React from 'react';
import '../../styles/common.css';

export const LoadingSkeleton = ({ className = '', style }) => {
  return (
    <div className={`skeleton ${className}`} style={style} />
  );
};

export const CardSkeleton = () => {
  return (
    <div className="card card-skeleton">
      <div className="card-skeleton__header">
        <div>
          <LoadingSkeleton style={{ height: '1.5rem', width: '6rem', marginBottom: '0.5rem' }} />
          <LoadingSkeleton style={{ height: '1rem', width: '8rem' }} />
        </div>
        <LoadingSkeleton style={{ height: '2rem', width: '2rem', borderRadius: '50%' }} />
      </div>
      
      <div className="card-skeleton__body">
        <LoadingSkeleton style={{ height: '2.5rem', width: '5rem', marginBottom: '0.5rem' }} />
        <LoadingSkeleton style={{ height: '1rem', width: '4rem' }} />
      </div>
      
      <LoadingSkeleton style={{ height: '3rem', width: '100%' }} />
    </div>
  );
};

export const TableSkeleton = ({ rows = 5, columns = 4 }) => {
  return (
    <div className="table-skeleton">
      <table className="table-skeleton__table">
        <thead>
          <tr>
            {Array.from({ length: columns }).map((_, i) => (
              <th key={i} className="table-skeleton__th">
                <LoadingSkeleton style={{ height: '1rem', width: '100%' }} />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <tr key={rowIndex}>
              {Array.from({ length: columns }).map((_, colIndex) => (
                <td key={colIndex} className="table-skeleton__td">
                  <LoadingSkeleton style={{ height: '1rem', width: '100%' }} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export const ChartSkeleton = () => {
  return (
    <div className="card">
      <LoadingSkeleton className="chart-skeleton__title" />
      <LoadingSkeleton className="chart-skeleton__chart" />
      <div className="chart-skeleton__legend">
        <LoadingSkeleton className="chart-skeleton__legend-item" />
        <LoadingSkeleton className="chart-skeleton__legend-item" />
        <LoadingSkeleton className="chart-skeleton__legend-item" />
      </div>
    </div>
  );
};

export const GridSkeleton = ({ items = 6 }) => {
  return (
    <div className="grid-skeleton">
      {Array.from({ length: items }).map((_, i) => (
        <CardSkeleton key={i} />
      ))}
    </div>
  );
};

export const HeatmapSkeleton = ({ vehicles = 6, sensorsPerVehicle = 2 }) => {
  const hours = Array.from({ length: 24 });

  return (
    <div className="heatmap">
      {/* Header */}
      <div className="heatmap__header">
        <div className="heatmap__timeline">
          <div className="heatmap__search-section">
            <LoadingSkeleton style={{ height: '1.6rem', width: '100%', borderRadius: '6px' }} />
          </div>
          <div className="heatmap__hours">
            {hours.map((_, i) => (
              <div key={i} className="heatmap__hour">
                <LoadingSkeleton style={{ height: '0.75rem', width: '80%', margin: '0 auto' }} />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Vehicle rows */}
      <div className="heatmap__vehicles-scroll">
        <div className="heatmap__vehicles">
          {Array.from({ length: vehicles }).map((_, vi) => (
            <div key={vi} className="heatmap__vehicle heatmap__vehicle--expanded">
              {/* Vehicle header */}
              <div className="heatmap__vehicle-header heatmap__vehicle-header--static">
                <LoadingSkeleton style={{ height: '0.85rem', width: '7rem' }} />
              </div>

              {/* Sensor rows */}
              <div className="heatmap__sensors">
                {Array.from({ length: sensorsPerVehicle }).map((_, si) => (
                  <div key={si} className="heatmap__sensor">
                    <div className="heatmap__sensor-info">
                      <LoadingSkeleton style={{ height: '0.7rem', width: '55%' }} />
                      <LoadingSkeleton style={{ height: '0.7rem', width: '30%' }} />
                    </div>
                    <div className="heatmap__blocks">
                      {hours.map((_, hi) => (
                        <LoadingSkeleton
                          key={hi}
                          style={{ flex: 1, height: '1.5rem', borderRadius: '3px' }}
                        />
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LoadingSkeleton;

